import Modal from "react-bootstrap/Modal";
import { gallery, gallery_online } from "./enum";

export default (props) => {
  const { ctrl, handle, type } = props;
  // const get = (a, b) => {
  //   return [7, 9].includes(a)
  //     ? `http://localhost:8081/img?url=https://render.albiononline.com/v1/item/${b}.png?quality=1`
  //     : `http://localhost:8081/img?url=https://render.albiononline.com/v1/item/T8_${b}.png?quality=1`;
  // };
  // const get = (a, b) => {
  //   return [7, 9].includes(a)
  //     ? `https://render.albiononline.com/v1/item/${b}.png?quality=1`
  //     : `https://render.albiononline.com/v1/item/T8_${b}.png?quality=1`;
  // };
  return (
    <Modal show={ctrl.value} onHide={ctrl.off} size="lg" centered>
      <Modal.Body>
        <div className="btn btn-primary w-100" onClick={() => handle("")}>
          empty
        </div>
        <div className="container-fluid">
          {gallery
            .filter((e) => e.type == type)
            .map((e, i) => (
              <div className={`row ${i % 2 == 0 ? "" : "bg-warning"}`} key={i}>
                {e.list.map((e, ii) => (
                  <div
                    className={`col-md-4 col-lg-2 col-4`}
                    onClick={() => handle(e)}
                    key={ii}
                  >
                    <img
                      className="ratio ratio-1x1 w-100"
                      src={e}
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                ))}
              </div>
            ))}
          {/* {gallery_online
            .filter((e) => e.type == type)
            .map((e, i) => (
              <div className={`row ${i % 2 == 0 ? "" : "bg-warning"}`} key={i}>
                {e.list.map((ee, ii) => (
                  <div
                    className="col-md-4 col-lg-2 col-4"
                    onClick={() => handle(get(e.type, ee))}
                    key={ii}
                  >
                    <img
                      className="ratio ratio-1x1 w-100"
                      src={get(e.type, ee)}
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                ))}
              </div>
            ))} */}
        </div>
      </Modal.Body>
    </Modal>
  );
};
